<script lang="ts">
	const features = [
		{
			name: 'Designated Marketplace for Travel',
			description:
				"Dive into a platform designed exclusively for travel itineraries, ensuring your content isn't overshadowed by unrelated listings.",
			icon: '/visuals/icons/marketplace.svg',
		},
		{
			name: 'Tailor-Made For Travel Creators',
			description:
				'Use our specialized tools, crafted for the nuances of itinerary creation, enriching your content presentation.',
			icon: '/visuals/icons/travel-creator.svg',
		},
		{
			name: 'Upload Your Content Once, Not Once a Week',
			description:
				'Design once and let your digital itineraries consistently contribute to your income, without the need for continuous updates.',
			icon: '/visuals/icons/long-live.svg',
		},
		{
			name: 'Profit from Your Network',
			description:
				'Convert trust and engagement into revenue, making each recommendation and share directly boost your financial success.',
			icon: '/visuals/icons/network.svg',
		},
		{
			name: 'Create Listings in Hours',
			description:
				'Breathe new life into existing content. Convert your content into curated itineraries.',
			icon: '/visuals/icons/fast.svg',
		},
		{
			name: 'SEO Done For You (soon)',
			description:
				'With optimized practices, Airheart ensures your itineraries rank higher, making it easier for travelers to find you.',
			icon: '/visuals/icons/seo.svg',
		},
		{
			name: 'Generous Profit Model',
			description:
				'Enjoy the fruits of your labor with a significant profit margin, aligning with your hard work and creativity.',
			icon: '/visuals/icons/money.svg',
		},
		{
			name: 'Earn Extra With Affiliate Links',
			description:
				'Integrate your affiliate links to earn additional commissions on related bookings.',
			icon: '/visuals/icons/hyperlink.svg',
		},
	]
</script>

<section
	id="secondary-features"
	aria-label="Features for building a portfolio"
	class="py-20 sm:py-32 lg:py-36"
	data-testid="SecondaryFeatures"
>
	<div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
		<div class="mx-auto max-w-6xl sm:text-center">
			<h2 class="text-3xl lg:text-4xl font-bold tracking-tight text-brand-gray-6">
				Unlock the True Earning Potential of Your Travel Content
			</h2>
			<p class="mt-2 text-lg text-brand-gray-5">
				With Airheart's intuitive and tailored tools, sharing and monetizing your journey is a
				seamless, rewarding endeavor.
			</p>
			<ul
				role="list"
				class="mx-auto mt-16 grid max-w-6xl grid-cols-1 gap-6 text-sm sm:mt-20 sm:grid-cols-2 md:gap-y-10 lg:max-w-none lg:grid-cols-4"
			>
				{#each features as feature}
					<li class="rounded-2xl border border-brand-gray-2 p-8">
						<img src={feature.icon} alt={feature.name} class="h-8 w-8 mx-auto" />
						<div class="mt-6 font-semibold text-brand-gray-6">
							{feature.name}
						</div>
						<p class="mt-2 text-brand-gray-5">{feature.description}</p>
					</li>
				{/each}
			</ul>
		</div>
	</div>
</section>
